import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import data from "../assets/chemical.jpg";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div className="MainBodySection mb-5">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="main-section-title">
									Importation, Storage & Distribution of Industrial Chemicals
								</h3>
							</div>

							<div className="col-md-12 bg-surface rounded p-3">
								<h5 className="font-semi-bold text-dim py-3">We take pride in delivering high-quality turnkey solutions across industries, providing data center setups, network infrastructure, and IT support to leading organizations. Our expertise spans across multiple sectors, ensuring operational efficiency, safety, and reliability for all our clients.</h5>
								<img 
									style={{
										width:"100%",
										height:"auto"
									}}
									src={data} 
								/>
								<div>
									<h6 className="font-bold text-light bg-primary rounded p-2 my-3">
										Various samples of Industrial Chemicals we deal with include: 
									</h6>
									<h5
										style={{
											borderLeft:"5px solid var(--primaryColor)",
											padding: "10px"
										}}
									>
										• <strong>Solvents:</strong> Acetone, Toluene, Ethanol<br/><br />
										• <strong>Acids & Bases:</strong> Sulfuric Acid, Hydrochloric Acid, Sodium Hydroxide<br/><br />
										• <strong>Cleaning & Disinfectants:</strong> Sodium Hypochlorite, Ammonium Compounds<br/><br />
										• <strong>Lubricants & Oils:</strong> Hydraulic Oil, Gear Oil, Transformer Oil<br/><br />
										• <strong>Specialty Chemicals:</strong> Adhesives, Coatings, Polymer Additives.
									</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}